module.exports = __webpack_public_path__ + "static/media/24UHCHR8.a5395457.jpg";